import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import ClientsConfig from './clients/clientsConfig'
import AdminsConfig from './admins/adminConfig'



export default class main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'clients'
        }
    }

    render() {
        return (
            <div className="animated fadeIn">
                <br />
                <br />
                <div className="row">
                    <div className="col-md-12">
                        <Nav tabs style={{cursor :"pointer"}}>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: this.state.activeTab === 'clients' })}
                                    onClick={()=> this.setState({ activeTab: "clients" })}
                                >
                                    Clientes
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: this.state.activeTab === 'admins' })}
                                    onClick={() => this.setState({ activeTab: "admins" })}
                                >
                                    Administradores
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: this.state.activeTab === 'messages' })}
                                    onClick={() => this.setState({ activeTab: "messages" }) }
                                >
                                    Mensajes
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="clients">
                                <ClientsConfig />
                            </TabPane>
                            <TabPane tabId="admins">
                               <AdminsConfig />
                            </TabPane>
                        </TabContent>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/administracion/main.js